export default __webpack_public_path__ + "static/media/julianne2.7011fa29.JPG";